import React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '../lib/utils';
import { Slot } from '@radix-ui/react-slot';
const tagvariants = cva('inline-flex items-center justify-center transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 font-gotham uppercase font-bold text-white rounded-md', {
    variants: {
        variant: {
            new: 'bg-brand-blue',
            'best-seller': 'bg-brand-orange',
            category: 'rounded-4xl border-2 border-brand-navy-2 text-brand-navy',
        },
        size: {
            xs: 'px-2 py-1.5 text-[8px] leading-full',
            sm: 'h-[34px] py-2 px-2.5 text-xs leading-full',
            lg: 'h-[34px] py-2.5 px-4 text-xs leading-full',
        },
        accent: {
            filled: '',
            outlined: '',
        },
        disabled: {
            false: '',
            true: 'cursor-default',
        },
    },
    compoundVariants: [
        {
            variant: 'category',
            className: 'normal-case',
        },
        {
            variant: 'category',
            size: 'lg',
            className: 'h-[33px] md:h-[40px] min-w-10 text-base leading-full py-2.5 px-5',
        },
        {
            variant: 'category',
            size: 'sm',
            className: 'h-[33px] text-base leading-full py-3.5 px-5',
        },
        {
            variant: 'category',
            accent: 'filled',
            className: 'bg-brand-navy-3',
        },
        {
            variant: 'category',
            disabled: false,
            className: 'hover:bg-brand-navy-3 active:bg-brand-navy-3',
        },
    ],
    defaultVariants: {
        variant: 'new',
        size: 'sm',
        accent: 'outlined',
        disabled: false,
    },
});
function Tag({ className, variant, accent, size, disabled, children, asChild, ...props }) {
    const Comp = asChild ? Slot : 'span';
    return (React.createElement(Comp, { className: cn(tagvariants({ variant, size, accent, disabled }), className), role: "status", ...props }, children));
}
export { Tag, tagvariants };
